import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme as themeConfig } from "@themes";

export const GeneralStyle = styled.div`
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  width: 100% !important;
  height: 87vh;
  overflow-x: hidden;
  overflow-y: auto;
  .grid-2-col {
    display: grid;
    grid-template-columns: 300px 2fr;
    grid-gap: 20px;
    margin: 0 1rem;
    width: 97.5%;
  }
`;

export const HR = styled.hr`
  background-color: ${({ theme }) => theme.neutral.gray[400]};
  height: 1px;
  width: 96.5%;
`;

export const ContentHeaderActivity = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const TitleActivity = styled.p`
  font-size: 20px;
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-weight: 700;
`;

export const SubtitleActivity = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.neutral.gray[2600]};
`;

export const ContentFilters = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1em 0;
  width: 100%;
`;

export const TableViewButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 40px;
  height: 40px;
  .filter-list-icon {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const ActionSection = styled.div`
  display: grid;
  grid-template-columns: 270px 2fr;
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .table-action {
    margin-right: 20px;
  }
`;

export const useStyles = makeStyles(() => ({
  contentForActivities: {
    backgroundColor: themeConfig.neutral.white,
    width: "fit-content",
  },
}));
